import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import CheckoutLayout from "./layouts/CheckoutLayout";
import All from './pages/all'
import './App.css';

// Route-level code splitting. The homepage (All) stays in the main bundle so
// the first paint is unchanged; every other page is fetched when it is opened.
const Privacy = lazy(() => import("./pages/privacy"));
const Use = lazy(() => import("./pages/use"));
const Reimbursement = lazy(() => import("./pages/Reimbursement"));
const Checkout = lazy(() => import("./pages/checkout"));
// Every SEO page (/iptv-*, /guias/*, /problemas/*, /dispositivos, ...) is served by
// one lazy catch-all, which also loads the content registry on demand.
const SeoRoute = lazy(() => import("./seo/SeoRoute"));

// Wraps a lazy route element. The fallback is empty so the header and footer
// (rendered by the layout around the route) stay on screen while a chunk loads.
const lazyRoute = (element) => <Suspense fallback={null}>{element}</Suspense>;

function App() {
  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<All />}/>
          <Route path="/privacypolicy" element={lazyRoute(<Privacy />)}/>
          <Route path="/termsandconditions" element={lazyRoute(<Use />)}/>
          <Route path="/refundpolicy" element={lazyRoute(<Reimbursement />)}/>
          {/* Catch-all: SEO pages, hubs, moved-path redirects and the noindex
              "not found" page. Explicit routes above always win. */}
          <Route path="*" element={lazyRoute(<SeoRoute />)} />
        </Route>
        <Route element={<CheckoutLayout />}>
          <Route path="/checkout" element={lazyRoute(<Checkout />)}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
